export enum DriverBehaviorMetric {
  SPEEDING = 'SPEEDING',
  HARSH_ACCELERATION = 'HARSH_ACCELERATION',
  HARSH_BRAKING = 'HARSH_BRAKING',
  HARSH_CORNERING = 'HARSH_CORNERING',
  SHOCK = 'SHOCK',
  COLLISION = 'COLLISION',
}
